import { FestivalSkeletonBlurBox } from "../../../../../../style/skeleton";
import {
  FestivalRankTop3Back,
  FestivalRankTop3ImageWrapper,
  RabbitFestivalRankTop3Item,
  RabbitFestivalRankTop3ItemText,
  RabbitFestivalRankTop3Wrapper,
} from "./style";

const RabbitFestivalRankTop3Skeleton = () => {
  const ranks = [2, 1, 3];
  return (
    <RabbitFestivalRankTop3Wrapper>
      {ranks.map((rank, i) => (
        <RabbitFestivalRankTop3Item rank={rank} key={i}>
          <FestivalRankTop3ImageWrapper rank={rank}>
            <FestivalRankTop3Back>
              <img
                src={`image-web/rabbit/rank${rank}-back.png`}
                alt="rank"
                className="back"
              />
            </FestivalRankTop3Back>
            <div className="rank">
              <img src={`image-web/rabbit/rank${rank}.png`} alt="rank" />
            </div>
          </FestivalRankTop3ImageWrapper>
          <RabbitFestivalRankTop3ItemText>
            <FestivalSkeletonBlurBox width="90px" height="21px" />
            <FestivalSkeletonBlurBox width="32px" height="14px" />
            <FestivalSkeletonBlurBox width="65px" height="14px" />
          </RabbitFestivalRankTop3ItemText>
        </RabbitFestivalRankTop3Item>
      ))}
    </RabbitFestivalRankTop3Wrapper>
  );
};

export default RabbitFestivalRankTop3Skeleton;
